import { Typography } from '@mui/material';
import React from 'react';

import { PointOfSale } from '@m4a3/api-client';
import { daysUpper } from '../../../utils/parsingUtils';
import { defaultTimezone } from '../../../utils/date-utils';
import { OpeningHourInputGroup } from './OpeningHourInputGroup';
import { OpeningHour } from '@m4a3/api-client/dist/models/shared/opening-hours.interface';

interface OpeningHourDialogContentProps {
  store: PointOfSale;
  openingHours: OpeningHour[];
  timezone: string;
  onChangeOpeningHours: (dayOfWeek: number, hours: {startTime: string, endTime: string}) => void;
}

export const OpeningHourDialogContent = ({store, openingHours, timezone, onChangeOpeningHours}: OpeningHourDialogContentProps) => {
  return (<>
    <Typography variant="h5">{store?.posName || 'New store'}</Typography>
    {timezone === defaultTimezone ? <></> : <Typography variant="subtitle2">All times are in {timezone} timezone</Typography>}

    {openingHours?.sort((a, b) => {
        const aIndex = daysUpper.indexOf(a.dow);
        const bIndex = daysUpper.indexOf(b.dow);
        return aIndex - bIndex;
      })
      .map((opening, i) => {
        return (
          <OpeningHourInputGroup
            opening={opening}
            key={`opening-hour-${i}`}
            dayIndex={i}
            timezone={timezone}
            onChange={onChangeOpeningHours}
          />
        );
      })}
    </>
  );
};
